import { TmBaseError } from '@/core/error/tmBaseError'

export class TmFormError extends TmBaseError {
  public name = 'TmFormError'
}
